import { SlideAction, SlideHideConditionType, SlideHidePageCondition, TutorialSection, TutorialSlide } from "../../tutorial.models";

export const DOCTOR_ONLY_PROFILE_SETTINGS_SLIDES: TutorialSlide[] = [
    {
        key: 'WelcomeCard',
        title: 'Welcome! 👋',
        messages: [{ text: "Let's dive into organizing your medical admin. While settings may not be the most thrilling task, it's important to get it right. By completing this, you'll help MedicAI understand your practice and train your AI Assistant to think like you." }],
        actions: [
            {
                text: 'Get Started',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideDoNotShowAgain: true,
        hideConditions: [
            { condition: SlideHidePageCondition.SIGNATURE_SET, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.PREFERRED_MEDICATION_SET, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.MEDICATION_BUNDLES_CREATED, type: SlideHideConditionType.AND },
        ],
    },
    {
        key: 'Add-Signature',
        title: 'Add Signature',
        messages: [
            { text: "First, let's edit your profile and add your signature. You'll need this for any scripts or letters that require a signature." },
            //{ text: 'Click "edit" and add your signature. We strongly suggest you add your signature now', class: 'primary' },
        ],
        expansionTarget: 'USER_PROFILE',
        highlightTarget: 'USER_PROFILE',
        forceOpenTarget: true,
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.SIGNATURE_SET, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Add-medBundles',
        title: 'Add Medication Bundles',
        expansionTarget: 'MEDICATION_BUNDLES',
        highlightTarget: 'MEDICATION_BUNDLES',
        forceOpenTarget: true,
        messages: [
            { text: "Most practices frequently prescribe similar medication bundles. Let's save you time by creating these bundles. This way, your AI Assistant can pick them up and prescribe appropriately under your supervision. Think along the lines of a combination of analgesics and antibiotics that you often use, or a migraine cocktail that you commonly prescribe." },
            // { text: 'Set this up now, but remember, you can always come back later.', class: 'primary' },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        hideConditions: [
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.MEDICATION_BUNDLES_CREATED, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.IS_ALLIED_SPECIALTY, type: SlideHideConditionType.OR },
        ],
        position: { x: 150, y: 450 },
    },
    {
        key: 'Add-predMed',
        title: 'Add Preferred Medication',
        expansionTarget: 'PREFERRED_MEDICATION',
        highlightTarget: 'PREFERRED_MEDICATION',
        forceOpenTarget: true,
        messages: [
            { text: "Your AI Assistant will also recommend medications based on your recorded consultations. To help it suggest your preferred formulations, list your go-to branded medications here. If done right, this can really save you time!" },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        hideConditions: [
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.PREFERRED_MEDICATION_SET, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.IS_ALLIED_SPECIALTY, type: SlideHideConditionType.OR },
        ],
        position: { x: 150, y: 450 },
    },
    {
        key: 'Profile_Finish',
        title: 'Completed Profile Settings!',
        messages: [
            { text: "You are done!" },
        ],
        expansionTarget: 'USER_PROFILE',
        highlightTarget: 'CLEAR',
        hasBackdrop: true,
        //position: { vertical: 'center', horizontal: 'center' },
        dimensions: { width: '450px' },
        actions: [
            {
                text: 'Close Tutorial',
                color: 'primary',
                actionName: SlideAction.SHOW_NOW,
            },

        ],
        position: { x: 700, y: 350 },
        progressBar: 100,
        hideDoNotShowAgain: true,
        hideConditions: [
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.SIGNATURE_SET, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.PREFERRED_MEDICATION_SET, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.MEDICATION_BUNDLES_CREATED, type: SlideHideConditionType.AND },
        ],
    },
];